<template>
  <BaseWeb :logo-img="logoPhoto"
           :app-img-arr="appPhotoArr" :app-name="appName" :company="companyName" :icp-num="icpNum"
           class="many_recruit_btn" :download-path="downloadPath"></BaseWeb>
</template>

<script>
import BaseWeb from '../components/baseWeb'
export default {
name: "strawberry",
  components:{
    BaseWeb:BaseWeb
  },
  data(){
     return{
       logoPhoto:require('../assets/strawberryImg/logo.png'),
       appPhotoArr:[
         {id:1,photo:require('../assets/strawberryImg/one.png')},
         {id:2,photo:require('../assets/strawberryImg/tow.png')},
         {id:3,photo:require('../assets/strawberryImg/three.png')},
         {id:4,photo:require('../assets/strawberryImg/four.png')},
       ],
       appName:'草莓兼职',
       companyName:'上海燃聚网络科技有限公司',
       icpNum:'沪ICP备2020032468号-1',
       downloadPath:'http://apk.hotbuybuy.com/cmjz_oppo_100.apk'
     }
  }
}
</script>

<style scoped>
.many_recruit_btn{
  --downBtn:rgb(252,90,103);
}
</style>



// WEBPACK FOOTER //
// src/components/strawberry.vue